import {
  dbui_v1_VerifyAuthResponse,
  dbuiV1VerifyAuthOptions,
  dbuiV1VerifyAuthQueryKey,
} from '@antimatterhq/asl-api-ts-v1';
import { useQueryClient } from '@tanstack/react-query';
import { useSuspenseQuery } from '@antimatterhq/ui/hooks/queries/useSuspenseQuery';
import { defaultOptions } from '@/utils/query';

export const useVerifyAuth = () => {
  return useSuspenseQuery({
    ...dbuiV1VerifyAuthOptions({
      ...defaultOptions(),
    }),
  });
};

export const useOptimisticUpdateVerifyAuth = () => {
  const queryClient = useQueryClient();

  return (
    updateAuth: (
      prev: dbui_v1_VerifyAuthResponse,
    ) => dbui_v1_VerifyAuthResponse,
  ) => {
    queryClient.setQueryData(
      dbuiV1VerifyAuthQueryKey({
        ...defaultOptions(),
      }),
      updateAuth,
    );
  };
};
